<mic-spinner-overlay ariaLabel="In Progress" color="primary" [loading]="loading">
  <div class="page-container">
    <!-- Page Header -->
    <div class="page-header">
      <button mat-icon-button routerLink="/user-profiles" class="back-button">
        <mat-icon>arrow_back</mat-icon>
      </button>
      <div class="header-content">
        <h2>Cadastrar Grupo de Usuário</h2>
        <p class="header-subtitle">Crie um novo grupo com permissões específicas</p>
      </div>
    </div>

    <app-user-profile-form (change)="onFormChange($event)" />

    <!-- Actions -->
    <div class="form-actions">
      <button mat-stroked-button color="primary" routerLink="/user-profiles">
        <mat-icon>close</mat-icon>
        <span>Cancelar</span>
      </button>
      <button mat-flat-button color="primary" (click)="submitForm()">
        <mat-icon>check</mat-icon>
        <span>Cadastrar Grupo</span>
      </button>
    </div>
  </div>
</mic-spinner-overlay>
